export const reportGlobalSalesTypes = {
  SET_REPORT_GLOBAL_SALES_FILTERS: 'SET_REPORT_GLOBAL_SALES_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};